import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { CreditCardIcon } from "components/Icons";
import { noop, useSessionCtx } from "utils";
import { makePMTitleMap } from "./common";
import AddPaymentMethodButtons from "./AddPaymentMethodButtons";

export const BlankSlate = ({ chooserConfig = {}, onCancel, onReady = noop }) => {
  const { formatMessage } = useIntl();
  const titleMap = makePMTitleMap(formatMessage);
  useEffect(onReady, [onReady]);
  const { sessionCtx } = useSessionCtx();
  const { flow } = sessionCtx;
  const addPMTitle =
    titleMap[flow] ||
    formatMessage({ defaultMessage: "Add a payment method", description: "Button label" });
  const handleOnCancel = onCancel && (() => onCancel({ state: "cancel" }));

  return (
    <div data-testid="pm-blankslate">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "#eee",
        }}
      >
        <CreditCardIcon size="30%" />
      </div>

      <AddPaymentMethodButtons
        title={addPMTitle}
        chooserConfig={chooserConfig}
        onCancel={handleOnCancel}
      />
    </div>
  );
};
